import clsx from 'clsx';
import React from 'react';
import { Typography } from '@/components/atoms/Typography';
import { useFetchStripePortalSessionMutation } from '@/api/hooks/useSubscription';

interface SubscriptionCardProps {
  active?: boolean;
  restaurantName: string;
  restaurantCityId: string;
  city: string;
  customerId?: string;
}

export const SubscriptionCard = ({ active = true, restaurantName, city, restaurantCityId, customerId }: SubscriptionCardProps) => {
  const [loading, setLoading] = React.useState(false);

  const { mutate: fetchStripeSession } = useFetchStripePortalSessionMutation();

  const handleManageSubscription = () => {
    if (!customerId) return;

    setLoading(true);
    fetchStripeSession(customerId, {
      onSuccess: (data) => {
        window.open(data.url, '_blank');
      },
      onError: (error) => {
        console.error(error);
      },
      onSettled: () => {
        setLoading(false);
      }
    });
  };

  return (
    <div className={clsx(active ? 'border-success' : 'border-red-600', 'border p-5 rounded-xl w-full space-y-3')}>
      <div className="flex gap-1 flex-col items-center justify-center">
        {active ? (
          <div className="bg-success/80 border-success border rounded-full w-fit px-4">
            <Typography variant="small" align="center" color="white">
              Actif
            </Typography>
          </div>
        ) : (
          <div className="bg-red-700/70 border-red-600 border rounded-full w-fit px-4">
            <Typography variant="small" align="center" color="white">
              Inactif
            </Typography>
          </div>
        )}
        <Typography variant="h3" align="center" weight="semibold">
          {restaurantName}
        </Typography>
      </div>

      <div className="border-t border-gray-200 w-full" />
      <div className="flex flex-col">
        {active ? <Typography variant="paragraph">Publicité lancée dans :</Typography> : <Typography variant="paragraph">Publicité arrêtée dans :</Typography>}
        <Typography variant="paragraph" weight="bold">
          {city || restaurantCityId}
        </Typography>
      </div>

      <button
        type="button"
        onClick={handleManageSubscription}
        disabled={loading}
        className="bg-primary mt-2 rounded-full p-2 w-full text-center text-white hover:bg-shades-primary-hover duration-200 ease-in-out"
      >
        {loading ? 'Redirection...' : "Gérer l'abonnement"}
      </button>
    </div>
  );
};
